import jsBridge from './index'
/**
 * H5获取当前app代理人数据
 */
export default function getAgentData() {
  return jsBridge('getAgentData')
}
